export default __webpack_public_path__ + "static/media/soupsalad.326f7ef7.png";